


































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfigsService from "@/services/api/configs.service";
import { EntityTypeDto, LanguageDto, EntityGroupDto } from "@/server/app.dtos";

@Component
export default class ActivitiesMenuList extends Vue {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Watch("currentTypeId")
  @Watch("currentGroupId")
  onChanged() {
    const p = Object.assign({}, this.$route.query, {
      skip: 0,
      idEntityType: this.currentTypeId,
      idEntityGroup: this.currentGroupId
    });
    this.$router.push({ query: p });
  }
  configsService: ConfigsService = new ConfigsService();
  groups: EntityGroupDto[] = [];
  types: EntityTypeDto[] = [];

  currentTypeId: number | null = null;
  currentGroupId: number | null = null;

  async created() {
    await this.Load();
  }

  async Load() {
    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;
    const q = this.$route.query;

    await this.configsService.Load("api/EntityGroups", query).then(result => {
      this.groups = result;
      if (q.idEntityGroup) {
        this.currentGroupId = parseInt(q.idEntityGroup as string);
      }
    });
    await this.configsService.Load("api/EntityTypes", query).then(result => {
      this.types = result;
      if (q.idEntityType) {
        this.currentTypeId = parseInt(q.idEntityType as string);
      }
    });
  }
}
